import React, { useState } from 'react';
// 4.x 版本正确导入：React 相关功能从 @apollo/client/react 导入
import { ApolloProvider, useMutation } from '@apollo/client/react';
// gql 仍从核心包导入（不变）
import { gql } from '@apollo/client';
import client from './apollo-client';
import './App.css';

// GraphQL Mutation 定义（不变，确保与 Koa 服务 Schema 匹配）
const CHAT_MUTATION = gql`
  mutation Chat($input: ChatInput!) {
    chat(input: $input) {
      success
      message
      data {
        reply
        model
        timestamp
      }
    }
  }
`;

// ChatComponent 组件逻辑（完全不变）
function ChatComponent() {
  const [message, setMessage] = useState('');
  const [chatHistory, setChatHistory] = useState([]);
  // 此处 useMutation 已从正确路径导入
  const [chat, { loading }] = useMutation(CHAT_MUTATION);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    try {
      const { data } = await chat({
        variables: {
          input: {
            messages: [{ role: 'user', content: message }],
            model: 'gpt-3.5-turbo'
          }
        }
      });
      if (data?.chat?.success) {
        setChatHistory([
          ...chatHistory,
          { role: 'user', content: message },
          { role: 'assistant', content: data.chat.data.reply }
        ]);
        setMessage('');
      }
    } catch (error) {
      alert('调用失败：' + error.message);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-header">
        💬 OpenAI 智能对话
      </div>
      <div className="chat-messages">
        {chatHistory.length === 0 ? (
          <div className="empty-state">
            <div className="empty-state-icon">💭</div>
            <div>开始你的第一次对话吧～</div>
          </div>
        ) : (
          chatHistory.map((msg, i) => (
            <div key={i} className={`message-wrapper ${msg.role}`}>
              <div className={`message-bubble ${msg.role}`}>
                {msg.content}
              </div>
            </div>
          ))
        )}
      </div>
      <form onSubmit={handleSubmit} className="chat-input-form">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="输入你的问题..."
          className="chat-input"
          disabled={loading}
        />
        <button
          type="submit"
          disabled={loading}
          className="chat-submit-btn"
        >
          {loading ? <span className="loading-dots">发送中</span> : '发送'}
        </button>
      </form>
    </div>
  );
}

// App 组件（ApolloProvider 从正确路径导入，不变）
function App() {
  return (
    <ApolloProvider client={client}>
      <div className="App">
        <h1 className="app-title">🚀 React + OpenAI</h1>
        <ChatComponent />
      </div>
    </ApolloProvider>
  );
}

export default App;